module.exports = __webpack_public_path__ + "static/img/rz.78395f8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/aboutUs/rz.jpg
// module id = 1RbU
// module chunks = 1